"use client";

// @components
import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="bg-background grid min-h-screen place-items-center p-6">
      <div className="mx-auto max-w-xs text-center">
        <h1 className="mb-4 text-4xl font-medium text-white sm:text-5xl">
          404
        </h1>
        <p className="text-foreground text-lg">
          Oops, it looks like the page you&apos;re looking for doesn&apos;t
          exist.
        </p>
        <Button asChild className="mt-6">
          <Link href="/">Go to Homepage</Link>
        </Button>
      </div>
    </div>
  );
}
